// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planoscontas_UpdateStatusInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /planoscontas/{id}/status
 *
 * Updates the status of a budget plan (activate/deactivate).
 */
import { registerContract } from './validate'

export interface Planoscontas_UpdateStatusInput {
status: string
}

registerContract('Planoscontas_UpdateStatusInput', {
  status: { type: 'string',  required: true },
})
